import React from 'react'
import { Box, Label, Input, Tooltip, FormField } from 'pcln-design-system'
import { Warning as WarningIcon, Calendar as CalendarIcon } from 'pcln-icons'

type DateFieldProps = {
  name: string
  label?: string
  placeholder?: string
  value: string
  error?: string
  errorZIndex?: number
  hideTooltip?: boolean
}

const DateField = React.forwardRef<
  HTMLInputElement,
  DateFieldProps & Record<string, unknown>
>(
  (
    {
      name,
      label = '',
      placeholder = '',
      value,
      error = '',
      errorZIndex = 1,
      hideTooltip = false,
      ...props
    },
    ref
  ) => {
    const dateFieldLargerStyle = value
      ? { height: '56px', paddingTop: '18px', paddingBottom: '10px' }
      : { height: '56px' }
    const showError = !hideTooltip && error !== ''

    return (
      <Box>
        <FormField>
          <Label autoHide htmlFor={name} width="auto">
            {label}
          </Label>
          <CalendarIcon color="primary" />
          <Input
            data-datepicker
            {...props}
            color={error ? 'error' : ''}
            id={name}
            name={name}
            borderRadius="lg"
            placeholder={placeholder || label}
            value={value}
            autoComplete="off"
            readOnly
            style={dateFieldLargerStyle}
            ref={ref}
          />
          {showError && <WarningIcon color="error" size={20} />}
        </FormField>
        {showError && (
          <Tooltip bottom right color="error" zIndex={errorZIndex}>
            {error}
          </Tooltip>
        )}
      </Box>
    )
  }
)

export default DateField
